const unsupportedAdUnits = ['offerWall'];

export const appToSupportedAdUnits = (app, activeProviders) => Object.keys(app.adUnits).filter((adUnitKey) => {
    // offerWall and banner are not supported currently
    if (unsupportedAdUnits.includes(adUnitKey)) return false;
    const adUnit = app.adUnits[adUnitKey];

    return adUnit.status !== 'inactive'
            || (activeProviders[adUnitKey] && activeProviders[adUnitKey].length > 0);
});

export default appToSupportedAdUnits;
